declare type TerminalType = {
  id: number;
  name: string;
};
declare type TerminalCategory = {
  id: number;
  name: string;
};

export function getTerminalCategories(): Array<TerminalCategory> {
  return [
    {id: 0, name: 'terminal_category.0'},
    {id: 1, name: 'terminal_category.1'}
  ];
}

export function getTerminalTypes(): Array<TerminalType> {
  return [
    {id: 0, name: 'terminal_type.0'}, // Generic / GSM
    {id: 1, name: 'terminal_type.1'}, // VoIP / SIP
    {id: 2, name: 'terminal_type.2'}, // Lync
    {id: 3, name: 'terminal_type.3'} // Fixed
  ];
}
